import { Spine } from 'pixi-spine';
import { Sprite } from 'pixi.js';
import { Tokens } from '~/utils/constants';
import { type CustomButton, type ITokenOptionItem } from '~/types/marketplace';

type TInteractiveObjectUnion = Sprite | Spine;

export function isInteractiveObject(target: unknown): target is TInteractiveObjectUnion {
  return target instanceof Spine || target instanceof Sprite;
}

// usefull for nullable types to avoid making types cast
export function isPredictOrNull<T>(target: T | null): target is T {
  return target !== null;
}

export const isToken = (value: any): value is Tokens => {
  return Object.values(Tokens).includes(value);
};

export const isCustomButton = (option: unknown): option is CustomButton => {
  return Boolean(option && typeof option === 'object' && 'type' in option);
};

export const isTokenOption = (option: unknown): option is ITokenOptionItem => {
  return Boolean(option && typeof option === 'object' && 'key' in option && !('type' in option));
};
